import { parseCookies } from 'nookies';
import { MAXIFY_TOKEN_COOKIE_NAME } from '@constants';

type GetToken = () => string | undefined;

const getToken: GetToken = () => {
  const cookies = parseCookies();

  return cookies[MAXIFY_TOKEN_COOKIE_NAME];
};

export default getToken;
